import React from "react";
import { useDispatch } from "react-redux";
import { closeModal } from "../../redux/features/modalSlice";
import { useCreateProductMutation } from "../../redux/services/productService/product.Services";
import { useProductForm } from "./hooks/useProductForm";
import { useCreateProductData } from "./hooks/useCreateProductData";
import ProductMedia from "./Reusablecomponents/productMedia";
import ProductFormFields from "./Reusablecomponents/ProductFormFields";
import ProductDropdowns from "./Reusablecomponents/ProductDropdowns";
import { successToast, errorToast } from "../../Utils/toast";
import { useNavigate } from "react-router";

function CreateProduct({ refreshData }) {
  const dispatch = useDispatch();
const navigate=useNavigate();
  const { formData, setFormData, handleChange } = useProductForm();

  const {
    categories,
    subCategories,
    states,
    cities,
    amenities,
    locations,
    filteredCities,
  } = useCreateProductData(formData);

  const [createProduct, { isLoading }] = useCreateProductMutation();
const handleSubmit = async (e) => {
  e.preventDefault();

  try {
    const form = new FormData();
    const selectedCategory = categories.find(
      (c) => c.id == formData.category_id
    );
    const selectedSub = subCategories.find(
      (s) => s.id == formData.subcategory_id
    );
    const selectedState = states.find(
      (s) => s.id == formData.state_id
    );
    const selectedCity = filteredCities.find(
      (c) => c.id == formData.city_id
    );
    const selectedLocation = locations.find(
      (l) => l.id == formData.location_id
    );
    form.append("categoryName",selectedCategory?.name || "");
    form.append("subcatName",selectedSub?.name || "" );
    form.append( "stateName",selectedState?.name || "");
    form.append("cityName",selectedCity?.name || "");
    form.append("location",selectedLocation?.name || "");
    form.append("title", formData.title || "");
    form.append("description",formData.description || "");
    form.append("price",formData.price || "");
    // form.append("discount_price",formData.discount_price || "");
    form.append("guest",formData.guest || "");
    form.append("bedroom",formData.bedroom || "");
    form.append("bed",formData.bed || "");
    form.append("bathroom",formData.bathroom || "");
    form.append("address",formData.address || "");
    form.append("latitude",formData.latitude || "");
    form.append("longitude",formData.longitude || "");
    form.append("status",formData.status || "active");
    form.append("noOfReviews",formData.noOfReviews || "0");
    form.append("rating",formData.rating || "0");
    form.append("bookingStatus",formData.bookingStatus || "0");
    form.append("amenities",formData.amenities.join(","));
    if (formData.thumbnail_image) {
      form.append(
        "thumbnail_image",
        formData.thumbnail_image
      );
    }
    formData.images.forEach((item) => {
      form.append("images", item.file);
      form.append( "image_titles", item.title  );
    });
    const res = await createProduct(form).unwrap();
    successToast( res?.message || "Product Created" );
    refreshData?.();
    dispatch(closeModal());
    navigate("/product-list");
  } catch (err) {
    console.log(err);
    errorToast(
      err?.data?.message || "Error"
    );
  }
};

  return (
    <div>

 <div className="page-header-breadcrumb all_breadcrumb">
                <div className="ms-md-1 mb-1 mb-md-0 ms-0 page_heading_breadcrumb">
                    <nav>
                        <h4 className="fw-semibold">
                            Add Ptroduct
                        </h4>
                        <ol className="breadcrumb mb-0">
                            <li className="breadcrumb-item">
                                <navigate to="/">
                                    Home
                                </navigate>
                            </li>

                            <li
                                className="breadcrumb-item active"
                                aria-current="page"
                            >
                                Add Product
                            </li>

                        </ol>

                    </nav>

                </div>
                <div className="page-title fw-semibold fs-18 mb-0">

                    <button
                        className="btn btn-primary me-2"
                        onClick={() => navigate(-1)}
                    >

                        <span>
                            <i className="fe fe-shopping-cart me-1"></i>
                        </span>

                        Product List

                    </button>

                </div>

            </div>

    <form onSubmit={handleSubmit} className="card p-4 shadow-sm">
      <ProductFormFields
        formData={formData}
        handleChange={handleChange}
      />
      <ProductDropdowns
        formData={formData}
        handleChange={handleChange}
        categories={categories}
        subCategories={subCategories}
        states={states}
        cities={filteredCities}
        locations={locations}
        amenities={amenities}
        setFormData={setFormData}
      />

      <ProductMedia
        formData={formData}
        setFormData={setFormData}
      />

      <button disabled={isLoading} className="btn btn-primary">
        {isLoading ? "Creating..." : "Create Product"}
      </button>

    </form>
    </div>
  );
}

export default CreateProduct;